// extracted by mini-css-extract-plugin
module.exports = {"root":"HowItWorksVideoModal_root__1bHXa","video":"HowItWorksVideoModal_video__TAPcv","closeBtn":"HowItWorksVideoModal_closeBtn__3qmqu"};